export const slideViewHeaderContainer = () => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'nowrap',
  height: '100%',
  justifyContent: 'space-between',
  width: '100%',
})

export const slideViewHeaderLeft = () => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'flex-start',
  width: '15%',
})

export const slideViewHeaderCenter = () => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'center',
  width: '70%',
  h1: {
    fontSize: 24,
  },
})

export const slideViewHeaderRight = () => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'flex-end',
  width: '15%',
})
